import Bugsnag from '@bugsnag/js';
import Cookie from 'js-cookie';
import axios, { AxiosRequestConfig } from 'axios';
import isString from 'lodash/isString';

import { NetworkError, ResourceError } from 'shared/utils/errors';
import { isCloudflareBlockedBot } from 'shared/utils/services/isCloudflareBlockedBot';

const handleError = (response) => {
  const status = response?.status;

  switch (true) {
    case status >= 500: {
      throw new NetworkError(response);
    }

    case status >= 400:
      if (isCloudflareBlockedBot(response)) {
        /*
         * Cloudflare bot blocking rules exclusively return a 403,
         * w/ an Access Denied message in the response data
         */
        Bugsnag.leaveBreadcrumb('Potential Bot Blocked');
      }
      throw new ResourceError(response);

    default: {
      throw new NetworkError(response);
    }
  }
};

export const setHeaderWithCSRF = () => {
  return {
    'X-CSRF-TOKEN': Cookie.get('csrf'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
};

export const requestService = (options: AxiosRequestConfig) => {
  if (!options.url || !isString(options.url)) {
    throw new Error('Required: url');
  }

  const requestOptions = {
    ...options,
    headers: { ...setHeaderWithCSRF(), ...options.headers },
    method: options.method || 'GET',
  };

  return axios
    .request(requestOptions)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return handleError(error?.response);
    });
};
